import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import SubNavComponent from './js/sub-nav.component';

ComponentsFactory.getInstance().define('sub-nav', SubNavComponent);
